/* eslint-disable no-prototype-builtins */
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Image from 'components/common/Image';
import imageResize from 'utils/imageResize';
import { Player } from 'video-react';
import 'node_modules/video-react/dist/video-react.css';

import getMaxString from 'utils/getMaxString';
import { IImageList } from './IImageList';
import { ImageSliderWrapper, ImageWrap } from './ImageList.styles';

const ITEM_WIDTH = 50;
const getVideoWidthHeight = (daimention) => {
  const wid = daimention?.width;
  const hit = daimention?.height;
  let aspect = wid / ITEM_WIDTH;
  return {
    width: ITEM_WIDTH,
    height: hit / aspect,
  };
};

const ImageSlider = ({
  images,
  alt = 'photo post image',
  variantToUse = '_detail',
  maxImagesToShow = 3,
}: IImageList) => {
  const filteredImages = images?.slice(0, maxImagesToShow);
  const getPostImagesHeight = (width, height) => {
    const imageWidth = ITEM_WIDTH;
    const aspectRatio = width / height;
    const h = (imageWidth / width) * height;
    if (aspectRatio >= 3) {
      return imageWidth / 3;
    }
    if (aspectRatio <= 0.66666) {
      return imageWidth * 1.5;
    }
    return h;
  };

  return (
    <ImageSliderWrapper length={images?.length}>
      {filteredImages?.length > 0 &&
        filteredImages[0]?.hasOwnProperty('dimensions') &&
        filteredImages?.map((el, i) => {
          if (el?.dimensions) {
            return (
              <ImageWrap
                height={
                  getPostImagesHeight(
                    el?.dimensions?.width,
                    el?.dimensions?.height
                  ) || 366
                }
                key={`media-${i}`}
              >
                {!el?.videoUrl || true ? (
                  <Image
                    src={
                      imageResize(el?.url, variantToUse) ||
                      el?.url ||
                      '/assets/img/tireTrace.png'
                    }
                    unoptimized
                    priority
                    fallbackSrc={el?.url}
                    alt={getMaxString(alt, 8)}
                    width={ITEM_WIDTH}
                    height={
                      getPostImagesHeight(
                        el?.dimensions?.width || ITEM_WIDTH,
                        el?.dimensions?.height || (ITEM_WIDTH * 2) / 3
                      ) || (ITEM_WIDTH * 2) / 3
                    }
                  />
                ) : (
                  <Player
                    autoPlay={false}
                    controls={false}
                    width={ITEM_WIDTH}
                    height={getVideoWidthHeight(el?.dimensions)?.height}
                    fluid={false}
                    poster={el?.url}
                    // src={el?.videoUrl}
                  >
                    <source src={el?.videoUrl} />
                  </Player>
                )}
              </ImageWrap>
            );
          }
        })}
    </ImageSliderWrapper>
  );
};
export default ImageSlider;
